import { Component, Input, inject } from '@angular/core';
import { getLocaleDateFormat, FormatWidth } from '@angular/common';
import { PIInvoice, PIBooking } from '@app/services/bavel-payment-manager-client.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-detail-references',
  templateUrl: './payment-detail-references.component.html',
  styleUrls: ['./payment-detail-references.component.scss'],
  standalone: false
})
export class PaymentDetailReferencesComponent {
  @Input() public editMode = false;
  @Input() public bookings?: PIBooking[];
  @Input() public invoices?: PIInvoice[];

  private translateService: TranslateService = inject(TranslateService);

  public bookingGuest(booking: PIBooking): string {
    let guest = '';
    if (!booking.guests || booking.guests.length === 0) {
      return guest;
    }
    if (booking.guests[0].title) {
      guest = guest + booking.guests[0].title + ' ';
    }
    if (booking.guests[0].firstName) {
      guest = guest + booking.guests[0].firstName + ' ';
    }
    if (booking.guests[0].lastName) {
      guest = guest + booking.guests[0].lastName;
    }
    return guest;
  }

  public getDateFormatForCalendar(): string {
    return getLocaleDateFormat(this.translateService.currentLang, FormatWidth.Short).toLowerCase().replace('yy', 'y');
  }
}
